export interface RaffleTicketHistoryItem {
    ticketNumber: string;
    announcedOn: Date;
}

export interface RaffleDashboardState {
    currentTicketNumber: string;
    announcementId: string;
    announcementCount: number;
    // Controlled from the raffle-control dashboard; the display mirrors this to decide
    // whether to speak announcements.
    soundEnabled: boolean;
    previousTickets: RaffleTicketHistoryItem[];
    cleared: boolean;
    updatedOn: Date;
    updatedById: string;
}

export interface RaffleDashboardDisplayStatus {
    soundEnabled: boolean;
    lastSeen: Date | null;
    updatedOn: Date;
}

export const DEFAULT_RAFFLE_DASHBOARD_STATE: RaffleDashboardState = {
    currentTicketNumber: '',
    announcementId: '',
    announcementCount: 0,
    soundEnabled: false,
    previousTickets: [],
    cleared: true,
    updatedOn: new Date(0),
    updatedById: '',
};

export const DEFAULT_RAFFLE_DASHBOARD_DISPLAY_STATUS: RaffleDashboardDisplayStatus = {
    soundEnabled: false,
    lastSeen: null,
    updatedOn: new Date(0),
};

/**
 * Pre-generated per-digit announcement audio, stored once (see the seed-raffle-digit-audio
 * script) so the display never calls the TTS API at runtime. `digitUrls[language][digit]` is
 * a public Appwrite Storage URL the display can play directly.
 */
export interface RaffleDigitAudio {
    digitUrls: Record<string, Record<string, string>>;
    updatedOn: Date;
}
